class MenuLocation {
    menuLocationSelect = null;

    menuLocationChange() {
        if (this.menuLocationSelect) {
            this.menuLocationSelect.addEventListener("change", (e) => {
                if (e.target.value) {
                    const locationName = e.target.querySelector(`[value='${e.target.value}'`).id;
                    document.cookie = `locationId=${e.target.value}; path=/;`;
                    document.cookie = `locationName=${locationName}; path=/;`
                    window.location.reload();
                }
            })
        }
    }

    constructor(locationSelect) {
        this.menuLocationSelect = locationSelect;
        this.menuLocationChange();
    }
}

export default MenuLocation;